import controller from './category-products.controller';
import template from './category-products.view.html';

let CategoryComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default CategoryComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/category/category-products/category-products.component.js
 **/